import { fromJS } from 'immutable'
import {
  POSITION_CREATE_REQUEST,
  POSITION_CREATE_SUCCESS,
  POSITION_CREATE_FAILURE,
  POSITION_CREATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case POSITION_CREATE_REQUEST:
      return state
        .set('isFetching', true)
    case POSITION_CREATE_SUCCESS:
      return state
        .set('positionCreate', fromJS(action.payload.createdPosition))
        .set('status', 200)
        .set('message', 'Created Successfully.')
        .set('isFetching', false)
    case POSITION_CREATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('positionCreate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case POSITION_CREATE_RESET:
      return state
        .delete('positionCreate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/position/position-create-reducer.js